/** Default optimization apex angle: a wide downward cone, about 4.5× the mounting height. */
export const DEFAULT_MAX_APEX_ANGLE_DEGREES = 77.5;
export const MIN_MAX_APEX_ANGLE_DEGREES = 0;
export const MAX_MAX_APEX_ANGLE_DEGREES = 180;
/** Above this the beam is wide enough to flag in the slider. */
export const WIDE_APEX_ANGLE_DEGREES = 80;
export const MAX_APEX_ANGLE_STEP_DEGREES = 0.1;

/** Snap to the slider step and keep the value inside 0–180°. */
export function clampMaxApexAngle(value: number): number {
  if (!Number.isFinite(value)) return DEFAULT_MAX_APEX_ANGLE_DEGREES;
  const steps = Math.round(value / MAX_APEX_ANGLE_STEP_DEGREES);
  const clamped = Math.min(
    MAX_MAX_APEX_ANGLE_DEGREES,
    Math.max(MIN_MAX_APEX_ANGLE_DEGREES, steps * MAX_APEX_ANGLE_STEP_DEGREES),
  );
  return Math.round(clamped * 10) / 10;
}

/** Ground radius / mounting height for a downward beam. Null once the beam reaches the horizon. */
export function groundReachMultiple(degrees: number): number | null {
  if (degrees >= 90) return null;
  const multiple = Math.tan((degrees * Math.PI) / 180);
  if (!Number.isFinite(multiple) || multiple < 0) return null;
  return multiple;
}

export function formatReachMultiple(multiple: number): string {
  if (multiple >= 100) return '>100';
  if (multiple >= 10) return multiple.toFixed(0);
  return multiple.toFixed(1);
}
